<template>
  <div class="footer1">
    <div class="footer">
      <div class="footer-address">
<!--        <div class="about">-->
<!--          <div class="title">关于我们</div>-->
<!--          <ul>-->
<!--            <li>-->
<!--              <div class="sub-title">-->
<!--                <img src="./assets/img/icon_mail.png" alt="" srcset="" />-->
<!--                E-Mail-->
<!--              </div>-->
<!--              <p>chinanurse@163.com</p>-->
<!--            </li>-->
<!--            <li>-->
<!--              <div class="sub-title">-->
<!--                <img src="./assets/img/icon_address.png" alt="" srcset="" />-->
<!--                Address-->
<!--              </div>-->
<!--              <p>北京市朝阳区东十里堡未来时大厦1701室</p>-->
<!--            </li>-->
<!--            <li>-->
<!--              <div class="sub-title">-->
<!--                <img src="../assets/img/icon_tel.png" alt="" srcset="" />-->
<!--                TEL.-->
<!--              </div>-->
<!--              <p>4006-518-512</p>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
        <div class="follow">
          <div class="title">关注我们</div>
          <div class="img-list">
            <transition name="el-fade-in-linear">
              <div
                class="qrcode"
                v-show="status"
                :style="{ left: left + 'px' }"
              >
                <img v-if="imgUrl != ''" :src="imgUrl" alt="" srcset="" />
              </div>
            </transition>

            <img
              src="./assets/img/icon_wx.png"
              @mouseover="openQrCode('-25', 'officialaccount.jpg', true)"
              @mouseleave="openQrCode('-25', 'officialaccount.jpg', false)"
              alt=""
              srcset=""
            />
            <img
              src="./assets/img/appdownload.png"
              @mouseover="openQrCode('65', 'app.png', true)"
              @mouseleave="openQrCode('65', 'app.png', false)"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <p class="info" @click="dialogVisible = true">《退款政策》</p>
      © 2023 chinanurse 北京爱护教育科技有限公司版权所有
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
        >京ICP备13034198号-2</a
      >
    </div>
    <el-dialog
      title="退费政策说明"
      :visible.sync="dialogVisible"
      width="80%"
      :center="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <div class="instructions">
        <h3>1.退费政策说明</h3>
        （1）直播课、录播课：购买课程7天内退课条件
        1>购买课程交付费用即确认双方辅导约定成立，报名7天内申请退款，扣除15%平台注册费用+15%违约金+已发生课时费<br />
        【解释】已发生课时费：<br />
        &nbsp;&nbsp;①录播课程：以已开通课程为准，如班主任发布录播课程，因个人原因未参与学习且无正式请假申请，按照课程发布所占课时扣除课时费用；<br />
        &nbsp;&nbsp;②直播课程以直播开播次数为准，如因个人原因未参与直播课且无正式请假申请，按照课程开播所占课时扣除课时费用；<br />
        （2）套餐项目享受优惠，归属于一个项目，不得分开申请：<br />
        &nbsp;&nbsp;①符合7天内退课条件的按照7天内退款流程办理； <br />
        &nbsp;&nbsp;②
        特殊情况被证实确实不能再继续参加课程学习而申请退款的，按照单项目市场价，同时扣除扣除15%平台注册费用+15%违约金；已发生课时进度的项目不予办理<br />
        （3）因在线和计算机软件等数字化商品不属于无理由退货的商品，报名网课7天后不得以任何要求终止学习，申请退款；<br />
        （4）美国心脏协会AHA课程：<br />
        &nbsp;&nbsp;①此课程自报名之日起有效期为365天，因此课程对上课人员数量及考试有严格要求，且教材、证书为整套名额，报名课程即已经占下名额，一年有效期内如因个人原因不能上课的，需扣除课程总金额的40%作为违约金，并同时扣除教材+配套证书费，后续继续上课需重新缴纳费用。<br />
        &nbsp;&nbsp;②课程有效期内因个人原因不能上课的，名额不再保留。<br />
        <h3>2.符合退款要求的按照以下流程办理</h3>
        （1）享受过课程的实物赠品：快递发出后，赠品费用办理退款是按照赠品原价扣除；若赠品未使用，且不影响二次销售，学员可将其寄回本机构，运费自行承担，不接受到付，赠品费用可不予扣除。<br />
        （2）开具过发票：需将发票寄回，寄回的费用由学员自行承担，不接受到付款收到发票后办理退款。<br />
        （3）差额退款：课程价格随活动和考试周期变动，不属于保价商品，因此产生的差价，概不退款。<br />
        <span>注意事项:<br />
        （1）退款时间：申请流程办理确认后，5个工作日内退还至个人名下银行账户<br />
        （2）缓存过课程到手机上的用户，如果缓存章节比例超过课程总章节的30%，不予办理退课退款。<br />
        （3）课程购买时间超过二个月 或 所学课程超过全部课程的50% 或
        直播开播次数占总课时比例超过50%，不予办理退课退款。<br />
        （4）反复恶意退课者（同一用户2次以上退课），将不适用以上规定。<br /></span>
        <h3>3.换课政策说明</h3>
        （1）购买网课7天内要求更换课程，所换课程价格小于原课程，可抵扣相关费用，予以退还差价；<br />
        （2）所需更换课程大于原课程价格，课抵扣相关费用，补齐差额；<br />
        （3）享受过课程的实物赠品，赠品费用在更换课程时将按照赠品原价扣除；<br />
        <span>换课注意事项: <br />（1）退款时间：操作换课程序后，退款部分将统一进行办理。<br />
        （2）缓存过课程到手机上的用户，如果缓存章节比例超过课程总章节的30%，不予办理换课退款。<br />
        （3）课程购买时间超过一个月 或
        所学课程超过全部课程的30%，不予办理换课退款。<br />
        （4）经过调换的课程不再享受二次调换且不接受退课申请。<br />
        （5）反复恶意换课者（同一用户2次以上换课），将不适用以上规定。<br />
        课程延期政策 延期政策说明 延期是增值性服务<br />
        （1）证书类课程在学习有效期内取得证书，可申请线上课程延期不超过3个月。<br />
        （2）有效期超过1年的课程，因个人原因可申请课程延期一次，不超过3个月。<br />
        注意事项:<br /> （1）若班级协议中有特殊约定的需按协议申请。<br />
        （2）奖学金班、签约班等特殊班级，达标时间请以班级说明帖/签约协议里的说明为准。<br /></span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: '',
      status: false,
      left: null,
      dialogVisible: false,
    }
  },
  methods: {
    openQrCode(left, url, status) {
      this.status = status
      this.left = left
      this.imgUrl = require(`./assets/img/${url}`)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .footer1{
    width: 100%;
  }
.footer {
  display: flex;
  justify-content: center;
  background-color: #fafafe;
  width: 100%;
  padding: 40px 0 0 0;
}
.instructions {
  line-height: 24px;
   font-size: 14px;
  span{
    font-size: 12px;
  }
}
.footer-address {
  /*width: 1280px;*/
  display: flex;
  justify-content: flex-start;
  .title {
    color: rgba(68, 68, 82, 100);
    font-size: 16px;
    text-align: left;
    margin-left: 39px;
    margin-bottom: 30px;
  }
  .about {
    flex: 4;
    min-width: 800px;
    ul {
      display: flex;
      justify-content: flex-start;
      li {
        border-right: 4px solid #f1f1ff;
        padding: 0 5%;
        .sub-title {
          line-height: 16px;
          color: rgba(68, 68, 82, 100);
          font-size: 16px;
          text-align: left;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
        p {
          margin-top: 16px;
          line-height: 24px;
          color: rgba(68, 68, 82, 100);
          font-size: 16px;
          text-align: left;
        }
      }
      li:first-child {
        flex: 2;
        padding-left: 0;
      }
      li:last-child {
        flex: 2;
        border: none;
      }
      li:nth-child(2) {
        flex: 3;
        min-width: 300px;
      }
    }
  }
  .follow {
    flex: 2;
    margin-left: 50px;
    .img-list {
      display: flex;
      justify-content: flex-start;
      position: relative;
      .qrcode {
        width: 100px;
        height: 100px;
        position: absolute;
        left: -25px;
        top: -110px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      img {
        cursor: pointer;
        width: 50px;
        height: 50px;
        margin-right: 40px;
      }
    }
  }
}
.footer-copyright {
  line-height: 20px;
  background-color: rgba(250, 250, 254, 1);
  color: rgba(68, 68, 82, 100);
  font-size: 14px;
  text-align: center;
  padding: 5px 0 20px 0;
  .info {
    background-color: #fafafe;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    text-decoration: underline;
    color: rgb(175, 174, 174);
    cursor: pointer;
  }
  a {
    text-decoration: none;
    color: rgba(68, 68, 82, 100);
  }
}
</style>
